import { Component } from '@angular/core';

import type { User } from '@core/account-types';
import { AdminsAvatarsComponent } from '@core/account-ui';
import type { DialogComponentI } from '@core/user-interface-legacy';
import { DialogBodyComponent, HeadingComponent } from '@core/user-interface-legacy';

interface NoAccessDialogData {
  title: string;
  description: string;
  imageSrc: string;
  admins: User[];
}

@Component({
  imports: [AdminsAvatarsComponent, DialogBodyComponent, HeadingComponent],
  selector: 'rt-no-access-dialog',
  templateUrl: './no-access-dialog.component.html',
  styleUrls: ['./no-access-dialog.component.less'],
})
export class NoAccessDialogComponent implements DialogComponentI<NoAccessDialogData, null> {
  public readonly ADMINS_LIMIT = 3;
  public title: string;
  public description: string;
  public admins: User[] = [];
  public imageSrc: string;

  public setDialogData(data: NoAccessDialogData, triggerUpdate: boolean): void {
    this.title = data.title;
    this.description = data.description;
    this.imageSrc = data.imageSrc;
    this.admins = data.admins;
  }
}
